import styled from '@mui/material/styles/styled';

const FileInput = styled('input')({ display: 'none' });

export { FileInput };